import { motion } from "framer-motion";
import { Reveal, Chapter, TrackCorner, EASE } from "./primitives";
import { useLanguage } from "../../i18n/LanguageContext";

export const Athletes = () => {
  const { t } = useLanguage();
  const A = t.athletes;
  return (
  <section className="relative overflow-hidden bg-white py-24 lg:py-32" data-testid="athletes-section">
    <div className="pointer-events-none absolute -left-28 top-0 text-kn-navy/[0.05]">
      <TrackCorner className="h-[320px] w-[320px]" />
    </div>
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <Chapter index="" label={A.eyebrow} />
          <h2 className="mt-6 text-4xl font-semibold leading-[1.12] tracking-tight text-kn-navy sm:text-5xl">
            {A.h2a}{" "}
            <span className="text-brand-gradient block font-serif font-normal italic">{A.h2b}</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-kn-navy/65">{A.body}</p>
          <div className="mt-10 divide-y divide-kn-navy/10 border-y border-kn-navy/10">
            {A.ring.map((r, i) => (
              <motion.div
                key={r}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.65, delay: i * 0.08, ease: EASE }}
                className="flex items-center justify-between py-3.5"
                data-testid={`athletes-ring-${i}`}
              >
                <span className="text-sm font-semibold text-kn-navy/70">{r}</span>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-kn-navy/40">0{i + 1}</span>
              </motion.div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative aspect-[4/3] overflow-hidden rounded-2xl" data-testid="athletes-image">
            <img src="/images/athlete-track.jpg" alt="An athlete in training" loading="lazy" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-kn-navy/80 via-kn-navy/20 to-transparent" />
            <p className="absolute bottom-6 left-8 font-mono text-[11px] tracking-[0.28em] uppercase text-white/85">
              {A.caption}
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
